import React,{Component} from 'react';
import './Start.css'

class Start extends Component{
    static handleGotoGov() {
        window.location.href="https://beian.miit.gov.cn";
    }
    render(){
        return(
            <div id='start' style={{height:'100%'}}>
                <table align="center" style={{height:'100%'}}>
                    <tbody>
                    <tr><td style={{verticalAlign:'bottom'}}>
                <span id='name' style={{display:'block',fontSize: '50px',textAlign:'center',color:'white',textShadow:'0px 0px 20px #ffa5a4',cursor: 'pointer'}} ><b>KARAS</b></span>
                    </td></tr>
                    <tr><td>
                        <h5  style={{color: '#fbfbfb',cursor: 'pointer',textShadow:'0px 0px 20px #ffa5a4'}}>
                            Merry go ‘round and around, Misery go ‘round and around, Quandary go ‘round and around
                        </h5>
                    </td></tr>
                    <tr><td valign="top">

                        <a onClick={this.props.handleBlogRoute} className='button' style={{textShadow:'0px 0px 30px #ff5b5b'}}>
                            Tick-Tock
                        </a>
                    </td></tr>
                    </tbody>
                </table>
                <div style={{position:'fixed',textAlign:'center',bottom:'5px',width:'100%'}}>
                    <span onClick={Start.handleGotoGov.bind(this)} style={{color:'white',cursor:'pointer'}}>湘ICP备17016414号-1</span>
                </div>
            </div>
        )
    }
}
export default Start;




// WEBPACK FOOTER //
// ./src/Compent/page/Start.js